import {ApplicationInsights, DistributedTracingModes} from '@microsoft/applicationinsights-web';
import {ReactPlugin} from '@microsoft/applicationinsights-react-js';

let reactPlugin: ReactPlugin | null = null;
let appInsights: ApplicationInsights | null = null;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: ApplicationInsights, initialize: Function}} - Object
 */
const createTelemetryService = (): { reactPlugin: ReactPlugin | null; appInsights: ApplicationInsights | null; initialize: Function; } => {

    /**
     * Initialize the Application Insights class
     * @param {string} connectionString - Application Insights Connection String
     * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
     * @return {void}
     */
    const initialize = (connectionString: string, browserHistory?: object): void => {
        if (!connectionString) {
            console.warn('Application Insights connection string not provided - telemetry will be disabled')
            return;
        }

        // Check if running in local development
        const isLocalDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        if (isLocalDevelopment) {
            console.log('Application Insights initialization skipped in development mode');
            return;
        }

        reactPlugin = new ReactPlugin();

        const extensionConfig: any = {
            [reactPlugin.identifier]: {}
        };

        // Only include history if provided (React Router v5 style)
        if (browserHistory) {
            extensionConfig[reactPlugin.identifier].history = browserHistory;
        }

        appInsights = new ApplicationInsights({
            config: {
                connectionString: connectionString,
                maxBatchInterval: 0,
                disableFetchTracking: false,
                enableCorsCorrelation: true,
                enableRequestHeaderTracking: true,
                enableResponseHeaderTracking: true,
                enableAjaxPerfTracking: true,
                enableUnhandledPromiseRejectionTracking: true,
                distributedTracingMode: DistributedTracingModes.W3C,
                extensions: [reactPlugin],
                extensionConfig: extensionConfig
            }
        });

        appInsights.loadAppInsights();
        
        // Track page views automatically
        appInsights.trackPageView();
    };

    return {reactPlugin, appInsights, initialize};
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;